<a [href]="en_link()" >English</a>
<a [href]="es_link()" >Español</a>
<a [href]="pt_link()" >português</a>
<a [href]="fr_link()" >français</a>
<a [href]="ru_link()" >русский</a>
<a [href]="zh_link()" >简体中文</a>
<a [href]="hi_link()" >हिन्दी </a>
<a [href]="bn_link()" >বাংলা</a>
<a [href]="ar_link()">العربية</a>
<a [href]="ur_link()">اردو</a>
